// extracted by mini-css-extract-plugin
export default {"l":"_2ec28ac0e3"};